module.exports = __webpack_public_path__ + "img/swiper_1.ec75fd51.png";